<template>
	<section class="news-list">
		<div class="relative container">
			<div class="all-offer light">
				{{ $fn.tr('მოიძებნა') + ' ' + list_count + ' ' + $fn.tr('სიახლე') }}
			</div>
		</div>
		<transition name="toggleContent" mode="out-in">
			<div class="news-grid-list container" v-if="!load" key="1">
				<template v-for="(item, index) in newsList">
					<NewsCard :data="item" :key="index" />
				</template>
			</div>
			<div key="2" v-else class="news-grid-list-load container"></div>
		</transition>
		<div
			class="news-list__not-found flex justify-center pt-55 pb-55 pl-10 pr-10"
			v-if="(not_found && !not_typed) || list_count == '0'"
		>
			<h2 class="font-55 bold f-center">
				{{ $fn.tr('შედეგი ვერ მოიძებნა') }}
			</h2>
		</div>
		<div class="mall-pagination-container" v-if="list_count > per_page_count">
			<el-pagination
				class="pagination mall-pagination container"
				layout="prev,pager, next"
				:page-size="per_page_count"
				:current-page.sync="page"
				:total="list_count"
				:disabled="false"
				:hide-on-single-page="true"
				@current-change="sendData"
				:key="'pagination'"
			/>
		</div>
	</section>
</template>

<script>
import NewsCard from './NewsCard.vue';
import fn from '../../helpers/func';

export default {
	props: ['contentData'],

	components: {
		NewsCard,
	},

	data() {
		return {
			page: 1,
			filteredList: null,
			load: false,
			_list_count: '',
			not_typed: true,
			not_found: false,
		};
	},
	watch: {
		page(ns, os) {
			let _url;
			_url = {
				path: '',
				query: { page: ns },
			};
			if (this.page !== parseInt(this.$route.query.page)) {
				this.$router.push(_url);
			}
		},
		check_loading: {
			immediate: true,
			handler(ns, os) {
				if (ns[0] && ns[1].query.page && this.page !== parseInt(ns[1].query.page)) {
					this.page = parseInt(ns[1].query.page);
					setTimeout(() => {
						this.sendData();
					}, 700);
				}
			},
		},
		per_page_count(ns, os) {
			this.$store.commit('main/setState', {
				key: 'per_page',
				val: ns,
			});
		},
		get_unic_id: {
			immediate: true,
			handler(ns, os) {
				if (ns)
					this.$store.commit('main/setState', {
						key: 'unique_id',
						val: ns,
					});
			},
		},
		search_list(ns, os) {
			this.filteredList = ns.data.list;
			this._list_count = ns.data.listCount;

			this.filteredList.length == 0 && this.search_val.length > 2
				? (this.not_found = true)
				: (this.not_found = false);

			if (this.search_val.length >= 2) this.not_typed = false;
		},
		search_val(ns, os) {
			if (ns.length > 2) {
				this.page = 1;
				console.log(ns);
				console.log(this.page);
			}
		},
		contentData: {
			immediate: true,
			handler(ns) {
				if (ns) {
					this.$store.commit('main/setState', {
						key: 'list_content_data',
						val: ns,
					});
				}
			},
		},
	},

	computed: {
		check_loading() {
			let arr = [this.per_page_count, this.$route, this.load];
			return arr;
		},
		newsList() {
			if (this.filteredList) {
				return this.filteredList;
			} else {
				return _.get(this.contentData, 'data.list');
			}
		},
		per_page_count() {
			return parseInt(_.get(this.contentData, 'conf.page_count'))
				? parseInt(_.get(this.contentData, 'conf.page_count'))
				: 8;
		},
		get_unic_id() {
			return _.get(this.contentData, 'conf.unicId');
		},
		list_count() {
			if (this.filteredList) {
				return this._list_count;
			} else {
				return _.get(this.contentData, 'data.listCount');
			}
		},

		search_list() {
			return this.$store.state.main.search_list;
		},
		search_val() {
			return this.$store.state.main.search_typed;
		},
	},

	methods: {
		async sendData() {
			this.load = true;

			const params = {
				componentUnicId: this.get_unic_id,
				id: _.get(this.$store.state.main.selected_menu, 'id'),
				pageNumber: this.page,
				searchText: this.search_val,
				// searchTerms: this.search_terms,
				taxonomies: {
					project: this.contentData?.conf?.taxonomies?.project,
				},
				perPage: this.per_page_count,
			};
			const res = await fn.postData('main/getDataList', params);
			window.scrollTo({ top: 0, behavior: 'smooth' });

			this.filteredList = res.data.list || null;
			this._list_count = res.data.listCount;
			this.load = false;
		},
	},

	mounted() {
		// this.load = true;
		if (!this.$route.query.page) {
			let _url = {
				path: '',
				query: { page: 1 },
			};
			this.$router.push(_url);
		}
		// setTimeout(() => {
		//   this.load = false;
		// }, 1000);
	},
};
</script>

<style lang="scss">
.news-list {
	padding-top: 89px;
	padding-bottom: 89px;
	background: $dirtywhite;
	@media (max-width: 767px) {
		padding-top: 55px;
		padding-bottom: 55px;
	}
	.all-offer {
		position: absolute;
		top: -310px;
		z-index: 9;
		color: $white;
		@media (max-width: 1439px) {
			top: -290px;
		}
		@media (max-width: 1023px) {
			top: -265px;
		}
		@media (max-width: 767px) {
			top: -235px;
		}
	}
	.news-grid-list {
		display: grid;
		grid-row-gap: 89px;
		grid-column-gap: 30px;
		grid-template-columns: repeat(3, minmax(0px, 1fr));

		@media (max-width: 1023px) {
			grid-template-columns: repeat(2, minmax(0px, 1fr));
			grid-gap: 15px;
			grid-row-gap: 55px;
		}
		@media (max-width: 767px) {
			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}
	}
	.news-grid-list-load {
		min-height: 70vh;
	}
	.mall-pagination-container {
		padding-bottom: 0;
		.mall-pagination {
			padding: 0;
		}
	}
}
</style>
